<template>
  <v-container fluid>
    <h1>{{document.title}}</h1>
    <div class="text">
        {{document.text.replace(/#*/g, '') }}
    </div>
  </v-container>
</template>

<script>
import data from "@/assets/content.json";
export default {
  metaInfo: {
    title: 'Articles'
  },
 data() {
   return {
     documents: data.articles,
     document: {}
   }
 },
 computed: {
   data() {
     return this.documents
   }
 },
 mounted() {
   this.getDoc()
 },
 watch: {
   $route() {
     this.getDoc()
   }
 },
 methods: {
   getDoc() {
       const docs = this.documents.filter(doc => doc.id === this.$route.params.id);
      if (docs.length > 0) 
        this.document =  docs[0];
   }
 }
};
</script>

<style>

</style>
